export default __webpack_public_path__ + "static/media/phone_in_hand.2cc22ff6.svg";